/**
 * A single transient side-toast — fixed bottom-center, animates in. Presentational only; the caller
 * owns when it shows and what it says. Shared by the version-update nudge and the invite-accepted
 * notification. `tone="gold"` marks a kintsugi accent (a good-news event, e.g. an invite accepted).
 */
export function Toast({
  title,
  body,
  actionLabel,
  onAction,
  onClose,
  tone = "info",
}: {
  title: string;
  body?: string;
  actionLabel?: string;
  onAction?: () => void;
  onClose?: () => void;
  tone?: "info" | "gold";
}) {
  return (
    <div className={`toast toast-${tone}`} role="status" aria-live="polite">
      <div className="toast-text">
        <strong>{title}</strong>
        {body && <span className="toast-sub">{body}</span>}
      </div>
      <div className="toast-acts">
        {actionLabel && onAction && (
          <button className="btn sm" onClick={onAction}>
            {actionLabel}
          </button>
        )}
        {onClose && (
          <button className="toast-x" onClick={onClose} aria-label="Dismiss">
            ×
          </button>
        )}
      </div>
    </div>
  );
}
